import RugCardHeader from './RugCardHeader'
export default RugCardHeader
